const SECTION = '#shopify-section-template--18729008005355__media_with_text_c6TNzN';

function initTwoSlideLoop() {
  const root = document.querySelector(SECTION);
  if (!root) return;

  const track = root.querySelector('.media-with-text');
  if (!track) return;

  function getSlides() {
    return Array.from(track.querySelectorAll('.media-with-text__item')).slice(0, 2);
  }

  function goTo(slides, i) {
    const target = slides[i];
    if (!target) return;
    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    track.dataset.mwtIndex = String(i);
  }

  // capture phase so we beat theme handlers
  root.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-mwt-prev]');
    const next = e.target.closest('[data-mwt-next]');
    if (!prev && !next) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const slides = getSlides();
    if (slides.length < 2) return;

    // Determine current index (stored), fallback to closest slide
    let idx = parseInt(track.dataset.mwtIndex || '0', 10);
    if (Number.isNaN(idx)) idx = 0;

    // If user swiped, sync to closest slide (0 or 1)
    const d0 = Math.abs(track.scrollLeft - slides[0].offsetLeft);
    const d1 = Math.abs(track.scrollLeft - slides[1].offsetLeft);
    idx = d1 < d0 ? 1 : 0;

    // Toggle between 0 and 1
    const nextIdx = 1 - idx;

    goTo(slides, nextIdx);
  }, true);

  // Initialize to slide 0
  const slides = getSlides();
  if (slides.length) track.dataset.mwtIndex = '0';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTwoSlideLoop);
} else {
  initTwoSlideLoop();
}